import React, { useEffect, useMemo, useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import { InputCategory } from '@api/InputCategories/InputCategory';
import { showAlertError } from '@utils/Alerts/Error';
import InputCategoriesService from '@api/InputCategories/InputCategoryCtrl';

interface InputCategoriesTabsProps {
    enabled: boolean;
    categoryIdSelected?: string;
    onSelectCategoryId: (categoryId?: string) => void;
}

export const InputCategoriesTabs: React.FunctionComponent<InputCategoriesTabsProps> = (props) => {
    const { enabled, categoryIdSelected, onSelectCategoryId } = props;
    const inputCategoriesService = useMemo(() => new InputCategoriesService(), []);
    const [categories, setCategories] = useState<InputCategory[]>([]);

    const getData = async () => {
        try {
            const data = await inputCategoriesService.getInputCategories();
            setCategories([
                {
                    id: undefined,
                    name: 'Todo',
                    description: ''
                } as unknown as InputCategory,
                ...data
            ]);
        } catch (error) {
            showAlertError(error);
        }
    };

    useEffect(() => {
        void getData();
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        onSelectCategoryId(newValue === 'todo' ? undefined : newValue);
    };

    const currentValue = categoryIdSelected || 'todo';

    return (
        <Tabs
            value={currentValue}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
                alignItems: 'center',
                opacity: enabled ? 1 : 0.5,
                pointerEvents: enabled ? 'auto' : 'none'
            }}
        >
            {categories.map((category, index) => (
                <Tab key={index} value={category.id || 'todo'} label={category.name} />
            ))}
        </Tabs>
    );
};

export default InputCategoriesTabs;
